import {
  ActionValidationError,
  type BladeActionSource,
  type ActionSubmitResult,
} from '../BladeActionSource';
import { ACTION_TRANSITION_STATUS, type ActionDescriptor } from '../actions';

// Static write source for the backendless preview (/shell-preview) and default
// tests. No network: it validates the same shape the live source requires (a status
// must be chosen for a transition) and resolves success, so the form primitive's
// submit/pending/success path renders without a live backend. No PHI.

export const mockActionSource: BladeActionSource = {
  async submitAction(
    descriptor: ActionDescriptor,
    values: Record<string, string>,
  ): Promise<ActionSubmitResult> {
    if (descriptor.kind === ACTION_TRANSITION_STATUS && !(values.status ?? '').trim()) {
      throw new ActionValidationError('Choose a status.', { status: 'Choose a status.' });
    }
    return { invalidateEntityIds: descriptor.entityId ? [descriptor.entityId] : [] };
  },
};
